import { useState, useRef, useEffect } from "react";
export enum LitComponent {
  LOS_AR,
  HAT,
  FAA,
  EDLOS,
  EARNINGS_CALCULATOR,
}

export const useImportLitComponent = ({ component }: { component: LitComponent }) => {
  const [isImported, setIsImported] = useState(false);
  const componentImported = useRef(false);

  useEffect(() => {
    if (componentImported.current) {
      setIsImported(true);
      return;
    }

    const loadLitComponent = async () => {
      try {
        switch (component) {
          case LitComponent.LOS_AR:
            await import("../../components/Lit/acc-wc-los-ar/acc-wc-los-ar.js");
            break;
          case LitComponent.FAA:
            await import("../../components/Lit/acc-wc-hat-faa/acc-faa-summary.js");
            break;
          case LitComponent.EDLOS:
            await import("../../components/Lit/acc-wc-los-ed/acc-wc-los-ed.js");
        }

        componentImported.current = true;
        setIsImported(true);
      } catch (error) {
        console.error("Failed to load component:", error);
      }
    };

    loadLitComponent();
  }, [component]);

  return { isImported };
};
